import PropTypes from 'prop-types';
import * as React from 'react';
import { RenderComp } from '../core/render-comp.component.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { usePopoverContext } from './popover.context.js';
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }
  return target;
}
const propTypes = {
  dialog: PropTypes.bool,
  labelText: PropTypes.string,
  fullBleed: PropTypes.bool,
  hideArrow: PropTypes.bool
};
const propKeysToRemove = Object.keys(propTypes);
const POPOVER_REQUIRED_SPACE_HORIZONTAL = 375;
const POPOVER_REQUIRED_SPACE_VERTICAL = 200;
function getTopOrBottom(position, triggerDomRect) {
  if (position === 'top' && triggerDomRect.y > POPOVER_REQUIRED_SPACE_VERTICAL) {
    return 'swan-popover-position-top';
  }
  if (position === 'bottom' && window.innerHeight - triggerDomRect.bottom > POPOVER_REQUIRED_SPACE_VERTICAL) {
    return 'swan-popover-position-bottom';
  }
  if (position === 'top') {
    return 'swan-popover-position-bottom';
  }
  return 'swan-popover-position-top';
}
function getHorizontalAlignment(position, triggerDomRect) {
  const triggerCenterX = triggerDomRect.left + triggerDomRect.width / 2;
  const posClassName = getTopOrBottom(position, triggerDomRect);
  const contentCenterX = POPOVER_REQUIRED_SPACE_HORIZONTAL / 2;
  if (triggerCenterX < contentCenterX) {
    return [posClassName, 'swan-popover-position-align-left', 'swan-popover-hide-arrow'];
  }
  if (window.innerWidth - triggerCenterX < contentCenterX) {
    return [posClassName, 'swan-popover-position-align-right', 'swan-popover-hide-arrow'];
  }
  return [posClassName];
}
function getClassNamesForPopoverPosition(launcherRef, position) {
  var _launcherRef_current;
  const launcherRectangle = launcherRef === null || launcherRef === void 0 ? void 0 : (_launcherRef_current = launcherRef.current) === null || _launcherRef_current === void 0 ? void 0 : _launcherRef_current.getBoundingClientRect();
  // const refRectangle = ref?.current?.getBoundingClientRect()
  if (!launcherRectangle) return ["swan-popover-position-".concat(position)];
  switch (position) {
    case 'left':
      if (launcherRectangle.left > POPOVER_REQUIRED_SPACE_HORIZONTAL) {
        return ['swan-popover-position-left'];
      }
      return getHorizontalAlignment('top', launcherRectangle);
    case 'right':
      if (window.innerWidth - launcherRectangle.right > POPOVER_REQUIRED_SPACE_HORIZONTAL) {
        return ['swan-popover-position-right'];
      }
      return getHorizontalAlignment('top', launcherRectangle);
    case 'top':
    case 'bottom':
      return getHorizontalAlignment(position, launcherRectangle);
    default:
      return [];
  }
}
const PopoverContent = renderWithRef('PopoverContent', propTypes, (props, ref) => {
  const {
    dialog,
    labelText,
    fullBleed,
    hideArrow = false,
    children
  } = props;
  const {
    expanded,
    position,
    launcherRef
  } = usePopoverContext();
  const accessibilityProps = dialog ? {
    role: 'dialog',
    'aria-modal': true
  } : {
    role: 'tooltip'
  };
  const classNameSet = new Set(['swan-popover', ...getClassNamesForPopoverPosition(launcherRef, position)]);
  if (hideArrow) classNameSet.add('swan-popover-hide-arrow');
  if (fullBleed) classNameSet.add('swan-popover-skin-full-bleed');
  return expanded ? /*#__PURE__*/React.createElement(RenderComp, {
    root: "div",
    forwardedRef: ref,
    classNames: classNameSet,
    propKeysToRemove: propKeysToRemove,
    props: _objectSpread({}, props, accessibilityProps),
    "aria-expanded": expanded,
    "aria-label": labelText
  }, children) : null;
});
PopoverContent.defaultProps = {
  dialog: false,
  labelText: '',
  fullBleed: false
};
export { PopoverContent };